<template>
  <div class="container">
    <!-- 面包屑 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>系统设置</el-breadcrumb-item>
      <el-breadcrumb-item>营业收支设置</el-breadcrumb-item>
    </el-breadcrumb>

    <div style="display: flex;justify-content: space-between">
      <div style="width: 20%">
        <div class="left_inner_con">
          <el-input size="mini"
                    style="position:sticky;z-index: 99;top:0;"
                    placeholder="输入关键字进行过滤"
                    v-model="filterText">
          </el-input>
          <el-tree
            :data="orgList"
            :props="treeProps"
            :highlight-current="true"
            node-key="id"
            :filter-node-method="filterNode"
            show-checkbox
            @check="handleCheckChange"
            ref="tree">
          </el-tree>
        </div>
      </div>
      <div style="rgb(222,222,222);width: 100%;height: 600px;">
        <el-button size="mini" @click="showExpendTypeDialog">新建支出类型</el-button>
        <el-button size="mini" @click="createOrgExpendType">机构配置支出类型</el-button>
        <el-card style="height: 550px;">
          <el-checkbox-group v-model="orgExpendType.expendTypeIds" size="small">
            <el-checkbox v-for="(expendType,index) in expendTypes"
                         :label="expendType.id"
                         :key="index">
              {{expendType.expendCnName}}
            </el-checkbox>
          </el-checkbox-group>
        </el-card>
        <br>
      </div>
    </div>

    <el-dialog
      title="新建支出类型"
      :visible.sync="expendTypeDialogVisible"
      width="40%"
      :close-on-click-modal="false"
    >
      <div style="background-color:#eff3f8;width:100%;height: 50px;position: absolute;top: 0;left: 0;z-index:0"></div>
      <div style="display: flex;justify-content: space-around;align-items: center;margin-top: 20px">
        <span>支出类型名称：</span>
        <el-input size="mini" v-model="expendType.expendCnName" style="width: 70%"/>
      </div>
      <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="closeExpendTypeDialog">取 消</el-button>
          <el-button size="mini" @click="createExpendType">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
export default {
  data(){
    return{
      orgList: [],
      filterText: '',
      authorities:'',
      treeProps: {
        label: 'orgName',
        children: 'children'
      },
      expendTypeDialogVisible:false,
      expendTypes:[],
      orgExpendTypes:[],
      expendType:{
        expendCnName:'',
        creator:''
      },
      orgExpendType:{
        orgIds:[],
        expendTypeIds:[]
      },
      selectOrgId:'',

    }
  },
  methods:{
    filterNode(value, data) {
      if (!value) return true;
      return data.orgName.indexOf(value) !== -1;
    },
    //组织机构树点击节点方法
    handleCheckChange(data) {
      this.selectOrgId = data.id;
      this.loadOrgExpendTypes();
    },
    async loadOrgExpendTypes(){
      const {data:res} = await this.$http.get(`/expendType/select/orgId/${this.selectOrgId}`);
      this.orgExpendType.expendTypeIds = res.data;
    },
    showExpendTypeDialog(){
      this.expendType.expendCnName ='';
      this.expendTypeDialogVisible = true;
    },
    closeExpendTypeDialog(){
      this.expendTypeDialogVisible = false;
    },
    // 加载机构树
    async loadOrg(){
      const {data:res} = await this.$http.get(`orgList/orgId/${this.orgId}`);
      this.orgList = [res.data];
    },
    async loadExpendTypes(){
      const {data:res} = await this.$http.get(`/expendType/selectAll`);
      this.expendTypes = res.data;
    },
    async createExpendType(){
      this.expendType.creator = this.userId;
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/expendType/add`, this.expendType);
      if (res.code === 200){
        this.$message.success("操作成功！")
      }
      await this.loadExpendTypes();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
      this.closeExpendTypeDialog();
    },
    async createOrgExpendType(){
      this.orgExpendType.orgIds = this.$refs.tree.getCheckedKeys();
      if (this.orgExpendType.orgIds.length === 0){
        return this.$message.warning("请选择机构！")
      }
      if (this.orgExpendType.expendTypeIds.length === 0){
        return this.$message.warning("请选择支出类型！")
      }
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'});
      const {data:res} = await this.$http.post(`/expendType/org/addExpendType`, this.orgExpendType);
      if (res.code === 200){
        this.$message.success("操作成功！");
      }
      await this.loadOrgExpendTypes();
      this.$loading({lock: true,fullscreen: true, text: 'Loading...'}).close();
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {
    this.orgId = window.sessionStorage.getItem('currentOrgId');
    this.userId = window.sessionStorage.getItem("userId");
    this.authorities = window.sessionStorage.getItem('authorities');
    this.loadOrg();
    this.loadExpendTypes();
  }
}
</script>

<style lang="less" scoped>
.container{
  height: 90vh;
  overflow-y: hidden;
}
.between{
  display: flex;
  justify-content: space-between;
//align-items: flex-start;
  height: 90vh;
}
.left_con::-webkit-scrollbar {
  width: 0 !important
}

.left_con{
//display: flex;
//justify-content: start;
  height: 100%;
  overflow-y: auto;
//flex: 1;
  width: 100px;
}
.left_inner_con{
  width: 100%;
  height: 90vh;
  overflow-y: auto;
}
.left_inner_con::-webkit-scrollbar {
  width: 0 !important
}
.table_container{
//flex: 1;
  width: 800px;
}
.el-table, .el-table__cell {
/deep/ th {
  padding: 2px ;
}
/deep/ td {
  padding: 2px ;
}
}
/deep/ .el-dialog__header{
  z-index: 1;
  position: relative;
  color: #333 !important;
.el-dialog__title{
  color: #333;
}
.el-dialog__close{
  color: #333 !important;
}
}
/deep/.el-dialog__body{
  padding-top: 10px;
}
.dialog-height{
  height: 600px !important;
}
.dialog-footer{
  display: flex;
  margin: 10px 0;
  justify-content: center;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Expend.vue